module.exports = {
    NODE_ENV: '"production"',
    BASE_API: '"https://agent.fei-wang.com.tw"',
    APP_ORIGIN: '"https://agent.fei-wang.com.tw"'
};



//////////////////
// WEBPACK FOOTER
// ./config/sit.env.js
// module id = 199
// module chunks = 103